import React from 'react';
import ActionMenu from '../../../../common/action/ActionMenu';
import { ListCell } from '../../../../common/cells/ListCell';
import StatusCell from '../../../../common/cells/StatusCell';
import StateMultiSelectColumnFilter, { StateMultiSelectFilterFn } from '../../../../common/filters/StateMultiSelectColumnFilter';
import TextColumnFilter from '../../../../common/filters/TextColumnFilter';

export const columns = (refresh) => {
    return [
        {
            Header: 'Státusz',
            accessor: 'state',
            id: 'state',
            show: true,
            className: 'status',
            Filter: StateMultiSelectColumnFilter,
            filter: StateMultiSelectFilterFn,
            Cell: props => <StatusCell row={props.row.original} />,
        },
        {
            Header: 'Partner',
            accessor: 'name',
            id: 'name',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Munkavállaló',
            accessor: 'employeeName',
            id: 'employeeName',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Jelenlegi Bankszámlaszám',
            accessor: 'currentBankAccountNumbers',
            id: 'currentBankAccountNumbers',
            show: true,
            Cell: props => <ListCell cell={props} delimiter=', ' />,
            Filter: TextColumnFilter,
        },
        {
            Header: 'Megjegyzés',
            accessor: 'comment',
            id: 'comment',
            show: true,
            Filter: TextColumnFilter,
        },
        {
            id: 'menu',
            show: true,
            headerClassName: 'actions',
            className: 'actions',
            Header: () => null, // No header
            Cell: value => <ActionMenu row={value.row.original} tabletype={'restrainpartner'} refresh={refresh} />,
        },
    ]
}